/** UTC start-of-day ms for stable day comparisons (publication_date strings). */
export const PUBLICATION_DAY_MS = 86_400_000;

export function publicationDayMs(isoOrDate: string | undefined | null): number | null {
  if (isoOrDate == null || String(isoOrDate).trim() === '') return null;
  const t = Date.parse(String(isoOrDate).trim());
  if (Number.isNaN(t)) return null;
  return Math.floor(t / PUBLICATION_DAY_MS) * PUBLICATION_DAY_MS;
}

export function formatPublicationDayLabel(dayMs: number): string {
  try {
    return new Date(dayMs).toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return '';
  }
}

export interface PublicationBounds {
  /** Min day ms in dataset */
  minDay: number;
  /** Max day ms in dataset */
  maxDay: number;
  /** Number of distinct day steps from min to max inclusive */
  dayCount: number;
}

export function publicationBoundsFromRisks(
  risks: { publication_date?: string }[]
): PublicationBounds {
  let min = Infinity;
  let max = -Infinity;
  for (const r of risks) {
    const d = publicationDayMs(r.publication_date);
    if (d == null) continue;
    min = Math.min(min, d);
    max = Math.max(max, d);
  }
  if (!Number.isFinite(min) || !Number.isFinite(max)) {
    const today = publicationDayMs(new Date().toISOString()) ?? Date.now();
    return { minDay: today, maxDay: today, dayCount: 1 };
  }
  const dayCount = Math.floor((max - min) / PUBLICATION_DAY_MS) + 1;
  return { minDay: min, maxDay: max, dayCount: Math.max(1, dayCount) };
}

export function dayIndexToMs(bounds: PublicationBounds, index: number): number {
  const i = Math.max(0, Math.min(bounds.dayCount - 1, index));
  return bounds.minDay + i * PUBLICATION_DAY_MS;
}
